module.exports = __webpack_public_path__ + "fonts/Inter-VariableFont_slnt_wght.9c9cff93.woff2";